import {TrackInfo} from "../../model/track-info";
import {TrackUtil} from "../../track-util";
import {TrackActionResult} from "../../model/track-action-result";

export class MaritalStatusAction{

    // Ids de status que precisam de conjuge
    static readonly idsCallSpose = ['608', '612'];

    //página onde ocorre a ação
    static readonly actionPageId = 'marital-status';
    
    // Proxima pagina caso precise de conjuge
    static readonly spousePageId = 'spouse';
    
    // Paginas que serão removidas caso <> Brasil
    static readonly removePages = [MaritalStatusAction.spousePageId];

    // Proxima pagica caso não precise de conjuge 
    static readonly cepPageId = 'cep';
    
    
    public static execute(data: any, track: TrackInfo[], originalTracks: TrackInfo[]){
        track = TrackUtil.rebuildTracks(this.actionPageId, track, originalTracks);
        const id = data.maritalStatus.maritalStatus;
        const filterId = this.idsCallSpose.find(x => x === id);

        if (!filterId) {
            return new TrackActionResult(data,
                track[track.findIndex(r => r.pageId === this.cepPageId)],
                track.filter(i => !this.removePages.includes(i.pageId)));
        } else {
            return new TrackActionResult(data,
                track[track.findIndex(r => r.pageId === this.spousePageId)],
                track);
        }
        
    }
}